import { useModalContext } from "../../CustomModal/ModalProvider.jsx";
import { useNavigate } from "react-router-dom";
import { guardianAreaService } from "../../../services/guardianAreaService.js";

const useAreaDelete = () => {
  const { showConfirm, showSuccess, showError } = useModalContext();
  const navigate = useNavigate();

  const handleDelete = async (id_code, areaName) => {
    const confirmed = await showConfirm(
      "Excluir Área?",
      `Tem certeza que deseja excluir a área "${areaName}" permanentemente?`
    );

    if (!confirmed) return;

    try {
      await guardianAreaService.deleteGuardianArea(id_code);

      await showSuccess("Sucesso!", `A área "${areaName}" foi excluída com sucesso.`);
      navigate("/areas");
    } catch (error) {
      console.error("❌ Erro ao excluir área:", error);
      await showError("Erro!", error.response?.data?.detail || "Erro ao excluir a área.");
    }
  };

  return { handleDelete };
};

export default useAreaDelete;
